import { createIcon, Icon } from '@chakra-ui/react';

export const DetalhesIcon = () => {
  return (
    <Icon h="1.5rem" w="1.5rem">
      <svg
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9449 5.27006C12.9449 7.62827 10.8113 9.54004 8.17948 9.54004C5.54765 9.54004 3.41406 7.62827 3.41406 5.27006C3.41406 2.91185 5.54765 1.00008 8.17948 1.00008C10.8113 1.00008 12.9449 2.91185 12.9449 5.27006Z"
          stroke="#001E64"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.06487 17C1.02093 16.7169 1 16.4262 1 16.1319C1 12.5787 4.2142 9.69867 8.17963 9.69867C8.28216 9.69867 8.38261 9.70055 8.48305 9.7043"
          stroke="#001E64"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1826 11.5212C14.524 12.6893 15.3568 14.3225 15.3568 16.1319C15.3568 16.4262 15.3338 16.7169 15.2919 17"
          stroke="#001E64"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2949 16.9995H1.06348"
          stroke="#001E64"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.782 7.5792C16.782 9.80091 14.7718 11.6021 12.2924 11.6021C9.81286 11.6021 7.80273 9.80091 7.80273 7.5792C7.80273 5.35749 9.81286 3.55634 12.2924 3.55634C14.7718 3.55634 16.782 5.35749 16.782 7.5792Z"
          stroke="#001E64"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1893 9.67431L19.6772 12.7994C20.1074 13.1851 20.1074 13.8102 19.6772 14.1957C19.2467 14.5812 18.5491 14.5812 18.1188 14.1957L14.5918 11.0354"
          stroke="#001E64"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
